import { render, staticRenderFns } from "./NovaPagination.vue?vue&type=template&id=47d15ef2&lang=pug&"
import script from "./NovaPagination.vue?vue&type=script&lang=js&"
export * from "./NovaPagination.vue?vue&type=script&lang=js&"
import style0 from "./NovaPagination.vue?vue&type=style&index=0&id=47d15ef2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports